export const convertLodashConstantToString = (constant: string | null): string => {
  return constant && typeof constant === 'string' && constant.length
    ? constant
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase())
    : '';
};
